    const modules = {
        Dashboard: ["edit", "view", "delete"],
        Board_Management: ["edit", "view", "delete"],
        School_Management: ["edit", "view", "delete"],
        Admissions: ["edit", "view", "delete"],
        News_Management: ["edit", "view", "delete"],
        Education: ["edit", "view", "delete"],
        Department: ["edit", "view", "delete"],
        Extracurricular: ["edit", "view", "delete"],
        Communication: ["edit", "view", "delete"],
        // Settings: ["edit", "view", "delete"],
       
    };

    export default modules